import axios from "@/api/axios";

import { DefaultService } from "./DefaultService";
import { PatientInterface } from "@/api/Interfaces/PatientInterface";
import { bus } from "@/main";

export default class PatientService extends DefaultService {
  static entityUrl = "/patients";

  static getPatient(
    clinic_id: number | string,
    patient_document: string
  ): Promise<PatientInterface> {
    return new Promise((resolve, reject) => {
      axios
        .get(`${this.entityUrl}/getInClinic/${clinic_id}/${patient_document}`)
        .then((response) => {
          resolve(response.data);
          bus.$emit("showLoadingSideModal", false);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  static getPatientEmail(
    clinic_id: number | string,
    email: string
  ): Promise<PatientInterface> {
    return new Promise((resolve, reject) => {
      axios
        .get(`${this.entityUrl}/getEmailInClinic/${clinic_id}/${email}`)
        .then((response) => {
          resolve(response.data);
          bus.$emit("showLoadingSideModal", false);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}
